import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.svg";
import logo_mob from "../img/logo.svg";
import MobileMenu from "./MobileMenu";

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Header() {

    const { link } = useContext(LinkContext);

    const { t } = useTranslation();
    const location = useLocation();

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'cs', label: 'CS' },
        { value: 'de', label: 'DE' },
        { value: 'es', label: 'ES' },
        { value: 'pl', label: 'PL' },
        { value: 'ru', label: 'RU' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    useEffect(() => {
        const root = document.getElementById("root"); // или другой общий контейнер
        if (i18n.language === "ru") {
            root.classList.add("lang-ru");
        } else {
            root.classList.remove("lang-ru");
        }
    }, [i18n.language]);
    useEffect(() => {
        const root = document.getElementById("root"); // или другой общий контейнер
        if (i18n.language === "pl") {
            root.classList.add("lang-pl");
        } else {
            root.classList.remove("lang-pl");
        }
    }, [i18n.language]);

    return (
        <div className="header-container bg-[#F1F1F1]">
            <div className="hidden max-w-[1220px] h-[60px] justify-between mx-auto xl:flex items-center">                
                <div className="flex items-center gap-[40px]">
                    <Link to="/"><img src={logo} alt="" className="w-[50px]"/></Link>
                    <Link to="/trading"><p className={`${location.pathname === '/trading' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.1')}</p></Link>
                    <Link to="/account"><p className={`${location.pathname === '/account' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.2')}</p></Link>
                    <Link to="/fees"><p className={`${location.pathname === '/fees' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.3')}</p></Link>
                    <Link to="/education"><p className={`${location.pathname === '/education' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.4')}</p></Link>
                    <Link to="/about"><p className={`${location.pathname === '/about' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.5')}</p></Link>
                    <Link to="/offers"><p className={`${location.pathname === '/offers' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[16px] hover:font-[500] transition-all`}>{t('header.7')}</p></Link>
                </div>
                <div className="flex items-center gap-[40px]">
                    <Dropdown
                        options={languages}
                        placeholder="EN"
                        onChange={handleChangeLang}
                        value={languages.find(lang => lang.value === currentLang)}
                    />
                    <a href={link}>
                        <div className="py-[10px] px-[20px] rounded-[40px] bg-[#35AB33] hover:scale-[0.95] transition-all">
                            <p className="text-[#fff] ibm-plex text-[16px]">{t('header.6')}</p>
                        </div>
                    </a>
                </div>
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[60px] relative z-[999]">
                <Link to="/"><img src={logo_mob} alt="" className="w-[40px]"/></Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                />
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
